import { createAsyncThunk } from '@reduxjs/toolkit';

import { RequestParamsBase } from '../Models/CommonRequestModels';

import { APIStepFunctionExecutionDetailsGetParams,
    APIStepFunctionExecutionTaskSignalPost,    APIStepFunctionExecutionTaskSignalPostParams,
    APIStepFunctionGetExecutionDetails,
    APIStepFunctionGetRunningList } from './StepFunctions.api';

export const fetchStepFunctionRunningList = createAsyncThunk('stepFunctions/fetchStepFunctionRunningList', async (params?: RequestParamsBase) => {
    const response = await APIStepFunctionGetRunningList(params);
    return response.data;
});

export const fetchStepFunctionExecutionDetails = createAsyncThunk('stepFunctions/fetchStepFunctionExecutionDetails', async (params: APIStepFunctionExecutionDetailsGetParams) => {
    const response = await APIStepFunctionGetExecutionDetails(params);
    return {
        ...response.data,
        executionId: params.executionId
    };
});

export const postStepFunctionExecutionTaskSignal = createAsyncThunk('stepFunctions/postStepFunctionExecutionTaskSignal', async (params: APIStepFunctionExecutionTaskSignalPostParams) => {
    await APIStepFunctionExecutionTaskSignalPost(params);
});
